import React from 'react';
import styles from './video.module.scss';

interface Props {
  videoId: string;
}

export const Video: React.FC<Props> = ({ videoId }) => {
  return (
    <div className={styles.video}>
      <iframe
        src={`https://www.youtube.com/embed/${videoId}?rel=0`}
        frameBorder={0}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen={true}
        title="YouTube Video"
      />
    </div>
  );
};
